import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { urlEndPoint } from 'src/app/common';
import { Podcast } from 'src/app/models/obs/podcast';
import { PodcastsService } from 'src/app/services/obs/podcasts.service';
import { PodcastGroupService } from 'src/app/services/obs/podcast-group.service';
import { PodcastGroup } from 'src/app/models/obs/podcastGroup';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { Tier1 } from 'src/app/models/obs/tier1';

@Component({
  selector: 'app-podcasts',
  templateUrl: './podcasts.component.html',
  styleUrl: './podcasts.component.scss'
})
export class PodcastsComponent implements OnInit, AfterViewInit {

  nextEpisodes: Podcast[];
  podcast: Podcast[] = [];
  dataCarousel: any;
  podcastGroupDesc: any;

  URL: string = urlEndPoint;
  showDescription: boolean[] = [];
  allPodcasts: Podcast[];

  iframeContainerRef: ElementRef | undefined;
  iframeArray: HTMLIFrameElement[] = [];
  filteredPodcasts: Podcast[] = [];
  facebookShared: boolean = false;
  twitterShared: boolean = false;
  currentPage: number = 1;
  podcastsPerPage: number = 10;
  resultsEnct: boolean = false;
  showPaginator: boolean = true;
  t1: Tier1;

  constructor(private t1S: Tier1Service, private podcastsService: PodcastsService, private podcastGroup: PodcastGroupService) { }

  ngOnInit() {
    this.podcastsService.getAll().subscribe((response: any) => {
      if (response.status === 'OK' && response.data) {
        this.allPodcasts = response.data.map((podcastData: any) => ({
          name: podcastData.name,
          group: '', // Mantenerlo vacío por ahora
          episode: podcastData.episode,
          description: podcastData.description,
          url: podcastData.url,
          urlSpotify: podcastData.urlSpotify,
          urlYoutube: podcastData.urlYoutube, //Agregado para youtube
          img: podcastData.img,
          publicationDate: podcastData.publicationDate, 
        lastUpdated: podcastData.lastUpdated,
        }));

        // Ordenar los podcasts por número de episodio en orden descendente
        this.allPodcasts.sort((a, b) => parseInt(b.episode) - parseInt(a.episode));

        // Después de obtener los datos de los podcasts, obtenemos los datos de los grupos
        this.podcastGroup.get_podgroup().subscribe((groupResponse: any) => {
          if (groupResponse.status === 'OK' && groupResponse.data) {
            this.podcastGroupDesc = groupResponse.data[0].description
            // Asignamos los nombres de los grupos a los podcasts correspondientes
            this.allPodcasts.forEach((podcast, index) => {
              const groupId = response.data[index].idgroup;
              const groupData = groupResponse.data.find((group: any) => group.id === groupId);
              if (groupData) {
                podcast.group = groupData.name;
              }
            });

            // Después de asignar los grupos, crea los iframes y realiza otras operaciones necesarias
            this.showDescription = this.allPodcasts.map(() => false);
            this.createIframesForPodcasts();
          }
        });
      }
    });

    this.getInitialText();
    this.getNextEpisodes();
    this.getImgCarousel();
  }

  /*Listamos podcast*/
  getNextEpisodes() {
    this.podcastsService.getNextEpisodes().subscribe(
      res => {
        this.nextEpisodes = res['data'];
      },
      err => {
        console.log(err);
      }
    )
  }

  /*Listamos imagenes carousel*/
  getImgCarousel() {
    this.podcastsService.getImgCarousel().subscribe(
      (res: any) => {
        if (Array.isArray(res.data)) {

          this.dataCarousel = res.data;

          const PodcastConImgCarousel = this.dataCarousel.filter(pod => pod.img);

          this.dataCarousel = PodcastConImgCarousel.map(pod => {
            return {
              longtitle: pod.name,
              img: pod.img,
              eventtype: 'Agenda prospectiva' + ' | ' + pod.episode,
            };
          });
        } else {
          console.error('La respuesta del servicio no es un arreglo válido:', res);
        }
      },
      err => {
        console.error('Error al obtener datos desde la API:', err);
      }
    );
  }

  getInitialText() {
    this.t1S.getOne(26).subscribe(
      res => {
        this.t1 = res['data'];
      },
      err => {
        console.error("algo salio mal!")
      }
    );
  }

  ngAfterViewInit() {
    this.iframeArray = [];
    this.iframeContainerRef = this.iframeContainerRef || new ElementRef(null);
    // Esperar a que se renderice el contenido y luego crear los iframes
    setTimeout(() => {
      this.createIframesForPodcasts();
    }, 0);
  }
  createIframesForPodcasts() {
    this.clearIframes();
    this.getPaginatedPodcasts().forEach((podcastObj, index) => {
      if (!this.iframeArray[index]) {
        const iframe = document.createElement('iframe') as HTMLIFrameElement;
        iframe.style.borderRadius = '5px';
        iframe.width = '100%';
        iframe.height = '152';
        iframe.frameBorder = '0';
        iframe.src = podcastObj.url;
        iframe.allow =
          'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
        iframe.setAttribute('loading', 'lazy');

        const container = document.getElementById(`reproductor-container${index}`);
        if (container) {
          container.appendChild(iframe);
          this.iframeArray.push(iframe); // Almacenar el iframe en el array
        }
      }
    });
  }

  performSearch(searchTerm: string) {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    this.filteredPodcasts = this.allPodcasts.filter(podcast =>
      podcast.name.toLowerCase().includes(lowerCaseSearchTerm)
    );

    this.currentPage = 1; // Reiniciar la página cuando se realice una búsqueda
    this.clearIframes();
    setTimeout(() => {
      this.createIframesForPodcasts();
    }, 10)
    this.showDescription = this.allPodcasts.map(() => false);

    if (lowerCaseSearchTerm === '') {
      this.filteredPodcasts = [];
      this.resultsEnct = false; // Cambiado a false para mostrar todos los foros
      this.showPaginator = true;
    } else {
      this.resultsEnct = this.filteredPodcasts.length === 0;
      this.showPaginator = !this.resultsEnct; // Actualizado para mostrar u ocultar el paginador
    }

  }

  toggleDescription(index: number) {
    this.showDescription[index] = !this.showDescription[index];
  }

  clearIframes() {
    // Eliminar todos los iframes del contenedor
    this.iframeArray.forEach((iframe) => {
      const container = iframe.parentElement;
      if (container) {
        container.removeChild(iframe);
      }
    });
    // Limpiar el array de iframes
    this.iframeArray = [];
  }

  changePage(pageNumber: number) {
    this.currentPage = pageNumber;
    this.clearIframes();
    setTimeout(() => {
      this.createIframesForPodcasts(); // Intenta llamar a createIframesForPodcasts() sin retraso
    })
    this.showDescription = this.allPodcasts.map(() => false);
  }

  getPaginatedPodcasts(): Podcast[] {
    const podcastsToDisplay = this.filteredPodcasts.length > 0 ? this.filteredPodcasts : this.allPodcasts;
    const startIndex = (this.currentPage - 1) * this.podcastsPerPage;
    return podcastsToDisplay && podcastsToDisplay.length > 0 ? podcastsToDisplay.slice(startIndex, startIndex + this.podcastsPerPage) : [];
  }
  
  getPageNumbers(): number[] {
    const podcastsToDisplay = this.filteredPodcasts.length > 0 ? this.filteredPodcasts : this.allPodcasts;
    const totalPages = podcastsToDisplay && podcastsToDisplay.length > 0 ? Math.ceil(podcastsToDisplay.length / this.podcastsPerPage) : 0;
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  isPageActive(pageNumber: number): boolean {
    return pageNumber === this.currentPage;
  }

  //REDES SOCIALES
  shareOnFacebook(url: string) {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
    // Marcar como compartido en Facebook
    this.facebookShared = true;
  }

  shareOnTwitter(url: string) {
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
    this.twitterShared = true;
  }
}
